import React from "react";
import "../style/loginAndRegister.css";
import "../index.css";

const Logout = () => {
  const handleSubmit = async (e) => {
    e.preventDefault();

    localStorage.setItem("token", null);
    window.location = "/login";
  };

  return (
    <div className="simple-card-with-fixed-height">
      <span className="label_of_login_form_fields align-center farsi">
        آیا از خروج مطمئنید؟
      </span>

      <div className="submit-button">
        <button
          className="btn btn-primary submit_btn_of_login_page"
          type="submit"
          onClick={handleSubmit}
        >
          <div className="farsi">خروج</div>
        </button>
      </div>
    </div>
  );
};
export default Logout;
